// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"505":"e938422b","584":"552860ea","815":"60dfe4b0"}[chunkId] + ".chunk.js";
};